// import axios from "axios";
// export const getAllCategoriesIMG = import.meta.env.VITE_APP_CATEGORY_IMG_URL
// export const getAllProductsIMG = import.meta.env.VITE_APP_ALLPRODUCTS_IMG_API_URL
// const BASE_API_URL = axios.create({
//     baseURL: import.meta.env.VITE_APP_API_URL,
//     headers: {
//         "Content-Type": "application/json"
//     },
//     withCredentials: true
// })

// export const getAllCategories = (slug) => BASE_API_URL.get(`/${slug}`);
// export const getProducts = (params) => BASE_API_URL.get('product', { params })

// export const registerUser = (data) => BASE_API_URL.post('site_user', data);
// export const loginUser = (data) => BASE_API_URL.post('login_user', data);
// export const checkAuth = () => BASE_API_URL.get('fetch_profile');
// export const logoutUser = () => BASE_API_URL.post('logout');


// export const syncCart = (data) => BASE_API_URL.post('usercart', data);
// export const fetchCart = () => BASE_API_URL.get('cartdetails');
// export const fetchProductDetails = (id) =>
//     BASE_API_URL.get(`productById?pId=${id}`);

// export const searchProductsAPI = (searchKey) =>
//     BASE_API_URL.get("/searchProducts", {
//         params: { query: searchKey }
//     });



import axios from "axios";

export const getAllCategoriesIMG = import.meta.env.VITE_APP_CATEGORY_IMG_API_URL;
export const getAllProductsIMG = import.meta.env.VITE_APP_ALLPRODUCTS_IMG_API_URL;

const BASE_API_URL = axios.create({
    baseURL: import.meta.env.VITE_APP_API_URL,
    headers: { "Content-Type": "application/json" },
    withCredentials: true
});

// Every call now passes route as a query param
export const getAllCategories = (slug) => BASE_API_URL.get('', { params: { route: slug } });
export const getProducts = (params) => BASE_API_URL.get('', { params: { route: 'product', ...params } });

export const registerUser = (data) => BASE_API_URL.post('', data, { params: { route: 'site_user' } });
export const loginUser = (data) => BASE_API_URL.post('', data, { params: { route: 'login_user' } });
export const checkAuth = () => BASE_API_URL.get('', { params: { route: 'fetch_profile' } });
export const logoutUser = () => BASE_API_URL.post('', {}, { params: { route: 'logout' } });

export const syncCart = (data) => BASE_API_URL.post('', data, { params: { route: 'usercart' } });
export const fetchCart = () => BASE_API_URL.get('', { params: { route: 'cartdetails' } });
export const fetchProductDetails = (id) => BASE_API_URL.get('', { params: { route: 'productById', pId: id } });
export const searchProductsAPI = (searchKey) =>
    BASE_API_URL.get("", {
        params: {
            route: "searchProducts",
            query: searchKey
        }
    });
